import React from 'react';
import * as moment from 'moment';

export const nomeTemplate = (rowData) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Nome</span>
            {rowData.Nome}
        </React.Fragment>
    );
};

export const InscricaoTemplate = (rowData) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Inscrição</span>
            {rowData.Inscricao}
        </React.Fragment>
    );
};

export const descSubGrupoBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Plano</span>
            {rowData.descSubGrupo}
        </React.Fragment>
    );
};

export const statusBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            <span className="p-column-title">Status</span>
            {rowData.Grupo}
        </React.Fragment>
    );
};

export const dataBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            {moment(rowData.Data).format('DD/MM/YYYY')}
        </React.Fragment>
    );
};
export const rowCor = () => {
    let resultado;
    resultado = {
        'row-suspenso': true,
    };
    return resultado;
};


export const colorTemplate = (rowData) =>  {
    let estiloInterno = ''
    let msg = ""
    switch (rowData.Status) {
        case 2:
            estiloInterno = "msg-inadimplente"
            msg = 'Contrato ativo com parcelas em atraso'
            break;
        case 3:
            estiloInterno = "msg-inadimplente-cancelado"
            msg = `Parcelas em aberto a ${rowData.DiasDesdeUltimaParcelaNaoPaga} dias`
            break;
        default:
            estiloInterno = "msg-inadimplente-ativo"
            msg = 'Nada consta'
            break;
            
    }
    return (
        <React.Fragment>
            <span className={estiloInterno}>{msg}</span>
        </React.Fragment>
    );
}